var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgUserFollow = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 48.107, height: 42 }, props, { children: [_jsx("path", { "data-name": "Path 150", d: "M41.742 13.136 37.5 17.38l-4.243-4.243-2.121 2.121 4.242 4.243-4.242 4.243 2.121 2.121 4.243-4.243 4.242 4.243 2.122-2.121L39.62 19.5l4.243-4.243Z", fill: "#ff4545" }), _jsx("path", { "data-name": "Path 151", d: "M15 3a7.5 7.5 0 1 1-7.5 7.5A7.5 7.5 0 0 1 15 3m0-3a10.5 10.5 0 1 0 10.5 10.5A10.5 10.5 0 0 0 15 0Z" }), _jsx("path", { "data-name": "Path 152", d: "M30 42h-3v-7.5a7.5 7.5 0 0 0-7.5-7.5h-9A7.5 7.5 0 0 0 3 34.5V42H0v-7.5A10.5 10.5 0 0 1 10.5 24h9A10.5 10.5 0 0 1 30 34.5Z" })] }))); };
export default SvgUserFollow;
